import { Button } from '@mui/material';

interface CustomButtonProps {
  text: string;
  onClick?: () => void;
  disabled?: boolean; // Propiedad para deshabilitar el botón
  color?: 'primary' | 'secondary' | 'inherit' | 'error' | 'info' | 'success' | 'warning'; // Valores válidos para `color`
}

export function CustomButton({ text, onClick, disabled, color = 'primary' }: CustomButtonProps) {
  return (
    <Button
      onClick={onClick}
      variant="contained"
      color={color}
      size="small"
      disabled={disabled} // Habilita o deshabilita el botón
      sx={{
        textTransform: 'none', // Evita que el texto se convierta a mayúsculas
        px: 4, // Padding horizontal
        py: 1, // Padding vertical reducido
        fontSize: '1.1rem', // Texto ligeramente más pequeño
        fontWeight: 'bold', 
        borderRadius: '50px', // Bordes redondeados
        boxShadow: '0px 3px 4px rgba(0, 0, 0, 0.4)', // Sombra alrededor del botón
        '&:hover': {
          boxShadow: disabled ? 'none' : '0px 4px 6px rgba(0, 0, 0, 0.85)', // Sombra en hover
        },
      }}
    >
      {text}
    </Button>
  );
}
